import { FormArray, FormControl, FormGroup, AbstractControl } from '@angular/forms';

/**
 * Outputs to the console the key, value, and error
 * @param control
 */
export function touchControlsWithErrors(control: AbstractControl) {
  // Uncommnet to debug if a control is pending
  // if (control.pending) {
  //   console.log(control);
  // }
  if (control instanceof FormControl) {
    if (control.invalid) {
      // Uncomment to debug what control is invalid
      // Object.keys(control.parent.controls).forEach((key) => {
      //   if (control.parent.controls[key] === control) {
      //     console.log('Key:', key, 'Value:', control.value, 'Error:', control.errors);
      //   }
      // });

      control.markAsTouched();
      control.updateValueAndValidity();
    }
  } else if (control instanceof FormArray) {
    Object.keys((control as FormArray).controls).forEach((key) => {
      touchControlsWithErrors(control.controls[key]);
    });
  } else if (control instanceof FormGroup) {
    Object.keys((control as FormGroup).controls).forEach((key) => {
      touchControlsWithErrors(control.controls[key]);
    });
  }
}
